import React, {Component} from 'react';
import {Link} from 'react-router-dom';
//Öö
export default class Title extends Component {
  constructor(props) {
    super(props);

    this.state = {
      op: 1,
    }

    this.toggleOp = this.toggleOp.bind(this);
  }

  toggleOp(n) {
    this.setState(function() {
      return {
        op: n
      }
    });
  }

  render() {
    return (
      <div className='title'>
        <ul className='title-list'>
          <li>
            <Link
              className='name'
              to='/'
              onMouseEnter={() => this.toggleOp(0.3)}
              onMouseLeave={() => this.toggleOp(1)}
              onMouseDown={() => this.toggleOp(0.7)}
              onMouseUp={() => this.toggleOp(1)}
              style={{opacity: this.state.op}}
            >
              AXEL DÖHLER
            </Link>
          </li>
          <li>
            <Link
              className='desc'
              to='/'
              onMouseEnter={() => this.toggleOp(0.3)}
              onMouseLeave={() => this.toggleOp(1)}
              onMouseDown={() => this.toggleOp(0.7)}
              onMouseUp={() => this.toggleOp(1)}
              style={{opacity: this.state.op}}
            >
              PHOTOGRAHPY
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Title.js